// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Stack, Group, Center } from '@/components/ui/layout';
import { Title, Text, Button } from '@/components/ui/core';
import { PasswordInput } from '@/components/ui/inputs';
import { IconLock, IconArrowLeft, IconCheck, IconX, IconShieldCheck } from '@tabler/icons-react';
import { AuthLayoutWrapper, PasswordStrength } from '../components';

export default function ResetSplit() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Reset password:', password);
  };

  const passwordsMatch = password === confirmPassword;

  const tips = [
    'Use at least 12 characters',
    'Mix uppercase and lowercase letters',
    'Include numbers and symbols',
    'Avoid common words or patterns',
    'Don\'t reuse old passwords',
  ];

  const splitContent = (
    <Stack gap="xl" p="xl" style={{ color: 'white' }}>
      <div>
        <Title order={1} c="white" mb="md">Create a strong password</Title>
        <Text size="lg" style={{ opacity: 0.9 }}>
          Follow these tips to keep your account secure.
        </Text>
      </div>

      <Stack gap="md" mt="xl">
        {tips.map((tip, index) => (
          <Group key={index} gap="sm">
            <IconCheck size={18} style={{ opacity: 0.8 }} />
            <Text size="sm" style={{ opacity: 0.9 }}>{tip}</Text>
          </Group>
        ))}
      </Stack>

      <Center mt="xl">
        <IconShieldCheck size={100} style={{ opacity: 0.3 }} />
      </Center>
    </Stack>
  );

  return (
    <AuthLayoutWrapper
      variant="split"
      splitContent={splitContent}
      gradientFrom="#10b981"
      gradientTo="#059669"
      backgroundImage="https://images.unsplash.com/photo-1557683304-673a23048d34?w=1200&auto=format&fit=crop"
    >
      <Stack gap="lg">
        {/* Back button */}
        <Button
          component={Link}
          to="/demo/auth-pages/reset-password"
          variant="subtle"
          size="xs"
          leftSection={<IconArrowLeft size={14} />}
          w="fit-content"
        >
          Back to variants
        </Button>

        {/* Header */}
        <div>
          <Title order={2}>Create new password</Title>
          <Text c="dimmed" size="sm" mt="xs">
            Your new password must be different from previously used passwords.
          </Text>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <Stack gap="md">
            <div>
              <PasswordInput
                label="New password"
                placeholder="Enter new password"
                leftSection={<IconLock size={16} />}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              {password && <PasswordStrength password={password} variant="requirements" />}
            </div>

            <PasswordInput
              label="Confirm new password"
              placeholder="Confirm your password"
              leftSection={<IconLock size={16} />}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              error={confirmPassword && !passwordsMatch ? "Passwords don't match" : undefined}
              rightSection={
                confirmPassword && (
                  passwordsMatch ? (
                    <IconCheck size={16} color="var(--mantine-color-green-6)" />
                  ) : (
                    <IconX size={16} color="var(--mantine-color-red-6)" />
                  )
                )
              }
            />

            <Button type="submit" fullWidth color="green" disabled={!passwordsMatch || password.length < 8}>
              Reset password
            </Button>
          </Stack>
        </form>

        {/* Back to Login */}
        <Center>
          <Button
            component={Link}
            to="/demo/auth-pages/login/split"
            variant="subtle"
            leftSection={<IconArrowLeft size={14} />}
          >
            Back to login
          </Button>
        </Center>
      </Stack>
    </AuthLayoutWrapper>
  );
}
